// The tour-tag pickers (notification rules' Tags, the auto-reply's Apply Tag, a user's Tags) label
// tags "category: tag". Operators have up to ~100k tags, so these load a page at a time as the list
// scrolls, sorted the way the labels read. They used to load the first 1,000 by name in one request:
// ~1.4 MB, and 1 in 10 opens took 8 s or more (prod, October 2026).
export const TOUR_TAG_PICKER_PAGING = {
    pageSize: 50,
    params: { sort: { field: 'category,name', order: 'ASC' } },
};

export default TOUR_TAG_PICKER_PAGING;
